export const staircaseConfig = {
    gameSlug: 'number-crunch',
    category: 'foudre_logique',
    variable: 'duration_ms',
    startValue: 5000,
    minValue: 1500,
    maxValue: 10000,
    stepSizesByPhase: [500, 300, 200, 100],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 24,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            ops: ['add', 'sub'],
            maxOperand: 20,
            label: 'Add/Sub <20',
        };
    }
    if (level <= 20) {
        return {
            level,
            ops: ['mul', 'div'],
            maxOperand: 12,
            label: 'Tables fluency',
        };
    }
    if (level <= 30) {
        return {
            level,
            ops: ['add', 'sub', 'mul', 'div'],
            maxOperand: 30,
            label: 'Mixed operations',
        };
    }
    if (level <= 40) {
        return {
            level,
            ops: ['estimate'],
            maxOperand: 100,
            label: 'Estimation rapide',
        };
    }
    return {
        level,
        ops: ['add', 'sub', 'mul', 'div', 'estimate'],
        maxOperand: 100,
        label: 'Calcul applique',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase. */
export const timing = {
    fixationMs: 300,
    equationMs: 500,
    feedbackMs: 600,
    itiMs: 500,
};
export const paradigmMeta = {
    slug: 'number-crunch',
    paradigm: 'Arithmetic fluency (Dehaene 1997 / Ashcraft 2007)',
    masterMage: 'Volta (foudre-logique)',
    category: 'foudre_logique',
    goal: "Fluence calcul mental : budget, estimation, vie pro, math anxiete reduction.",
};
//# sourceMappingURL=params.js.map